import React from 'react';
import Button from 'tradevan-ui/Button';
import {
  ControlPanelStyled,
  FlexStyled,
  GapStyled,
  InputNumberStyled,
} from '../styles';
import UiStateI from '../type';

interface ControlPanelProps {
  uiState: UiStateI;
  setUiState: (uiState: UiStateI) => void | Promise<void>;
  onClose: () => void;
  customChild: JSX.Element;
}

const ControlPanel = (props: ControlPanelProps): JSX.Element => {
  const { uiState, setUiState, onClose, customChild } = props;

  const isFirstPage = uiState.currentPage === 1;
  const isLastPage = uiState.currentPage === uiState.pages;

  const goToFirstPage = () =>
    !isFirstPage && setUiState({ ...uiState, currentPage: 1 } as UiStateI);

  const goToLastPage = () =>
    !isLastPage &&
    setUiState({ ...uiState, currentPage: uiState.pages } as UiStateI);

  const goToPreviousPage = () =>
    !isFirstPage &&
    setUiState({
      ...uiState,
      currentPage: uiState.currentPage - 1,
    } as UiStateI);

  const goToNextPage = () =>
    !isLastPage &&
    setUiState({
      ...uiState,
      currentPage: uiState.currentPage + 1,
    } as UiStateI);

  const onPageChange = (value: string) => {
    try {
      if (!/^[0-9]+$/.test(value) || parseFloat(value) <= 0) return;
      if (parseFloat(value) > uiState.pages) {
        return;
      }

      setUiState({
        ...uiState,
        currentPage: parseFloat(value),
      } as UiStateI);
    } catch (e) {
      // alert(e);
    }
  };

  const isMinZoom = uiState.scale < 0.6;
  const isMaxZoom = uiState.scale >= 2.5;

  const zoomOut = () =>
    !isMinZoom && setUiState({ ...uiState, scale: uiState.scale - 0.12 });

  const zoomIn = () =>
    !isMaxZoom && setUiState({ ...uiState, scale: uiState.scale + 0.12 });

  return (
    <ControlPanelStyled>
      <GapStyled />
      <FlexStyled>
        <Button disabled={isFirstPage} onClick={goToFirstPage}>
          {'<<'}
        </Button>
        <Button disabled={isFirstPage} onClick={goToPreviousPage}>
          {'<'}
        </Button>
        <span>
          第
          <InputNumberStyled
            style={{ textAlign: 'center' }}
            inputGroupProps={{
              style: {
                display: 'inline-block',
                width: 'initial',
              },
            }}
            name=""
            max={uiState.pages}
            min={1}
            value={uiState.currentPage}
            onChange={(e) => onPageChange(e.target.value)}
          />
          頁 共 {uiState.pages} 頁
        </span>
        <Button disabled={isLastPage} onClick={goToNextPage}>
          {'>'}
        </Button>
        <Button disabled={isLastPage} onClick={goToLastPage}>
          {'>>'}
        </Button>
      </FlexStyled>
      <GapStyled />
      <FlexStyled>
        <Button disabled={isMinZoom} onClick={zoomOut}>
          <i className="icon-minus" />
          {/* ZoomOutIcon */}
        </Button>
        <span>{((uiState.scale * 100) / 1.2).toFixed()}%</span>
        <Button disabled={isMaxZoom} onClick={zoomIn}>
          {/* ZoomInIcon */}
          <i className="icon-plus" />
        </Button>
        {customChild}

        <Button onClick={onClose}>關閉</Button>
      </FlexStyled>
      <GapStyled />
    </ControlPanelStyled>
  );
};

export default ControlPanel;
